import { DeleteButton, AccessCheck } from "@components";
import { UserRoleEnum } from "features/users/types";
import { workspacesService } from "features/workspaces/services/workspaces-service";

export const DeleteProjectButton = ({ id }: { id: number }) => (
  <AccessCheck minAccessLevel={UserRoleEnum.Admin} showAlert={false}>
    <DeleteButton id={id} deleteService={workspacesService.deleteProject} label="Project" />
  </AccessCheck>
);
